import { motion } from "framer-motion";
import { CircleDot, Wifi, Coffee } from "lucide-react";
import { CAFE } from "@/data/content";

const AMENITIES = [
  { icon: CircleDot, label: "Pool Table", note: "Stay for a game after your buna" },
  { icon: Coffee, label: "Coffee Ceremony", note: "Traditional buna, brewed to order" },
  { icon: Wifi, label: "Free Wi-Fi", note: "Work, read or linger a while" },
];

export default function Reservation() {
  return (
    <section id="reserve" data-testid="reservation-section" className="bg-cafe py-28 md:py-40">
      <div className="mx-auto max-w-[1500px] px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9 }}
          className="max-w-4xl"
        >
          <p className="mb-6 font-body text-xs uppercase tracking-[0.35em] text-accent">Visit</p>
          <h2 className="mb-8 font-display text-4xl leading-tight tracking-tight text-[var(--text)] sm:text-5xl lg:text-6xl">
            Come sit, sip<br />&amp; play a round.
          </h2>
          <p className="mb-14 max-w-xl font-serif-c text-xl leading-relaxed text-[var(--text)]/70">
            No bookings, no fuss — just walk in. Order a macchiato, rack up the pool table and settle into the room.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, delay: 0.1 }}
          className="grid grid-cols-1 gap-px overflow-hidden rounded-sm border border-[var(--line)] bg-[var(--line)] sm:grid-cols-3"
        >
          {AMENITIES.map((a) => (
            <div key={a.label} data-testid={`amenity-${a.label.toLowerCase().replace(/\s+/g, '-')}`} className="bg-surface p-8">
              <a.icon size={26} className="text-accent" />
              <p className="mt-6 font-serif-c text-2xl text-[var(--text)]">{a.label}</p>
              <p className="mt-1 font-body text-sm leading-relaxed text-[var(--text)]/50">{a.note}</p>
            </div>
          ))}
        </motion.div>

        <div className="mt-14 grid grid-cols-1 gap-10 sm:grid-cols-2 lg:max-w-3xl">
          <div>
            <p className="font-body text-xs uppercase tracking-[0.2em] text-accent">Hours</p>
            <p className="mt-3 font-serif-c text-lg leading-relaxed text-[var(--text)]/80">
              Mon–Fri · 09:00–22:00<br />Sat · 09:30–22:00<br />Sun · 10:00–22:00
            </p>
          </div>
          <div>
            <p className="font-body text-xs uppercase tracking-[0.2em] text-accent">Find us</p>
            <a
              href={CAFE.mapUrl}
              target="_blank"
              rel="noreferrer"
              data-testid="res-map-link"
              className="mt-3 block font-serif-c text-lg leading-relaxed text-[var(--text)]/80 link-underline"
            >
              {CAFE.addressShort}<br />{CAFE.city}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
